<template>
    <div class="full-height d-flex" style="position: relative">
        <div class="flex-grow-1" style="position: absolute; z-index: 0">
            <v-tabs
                centered
                color="primary"
                v-model="displayTabContent"
                style="position: sticky; top: 0; z-index: 10"
            >
                <v-tab class="flex-grow-1 flex-equal">Website Terms and Conditions</v-tab>
                <v-tab class="flex-grow-1 flex-equal">Privacy Policy</v-tab>
            </v-tabs>
            <v-tabs-items
                v-model="displayTabContent"
                style="overflow-y: auto"
            >
                <v-tab-item>
                    <div class="mt-5 mx-16 full-height d-flex flex-column">
                        <div class="font-weight-bold my-7 text-h4">Website Terms and Conditions and Privacy Policy for Tasklogix (Pty) Ltd</div>
                        <div class="body-1">
                            Welcome to Tasklogix. These terms and conditions (“Terms”) govern your access to and use of Tasklogix (the “Website”).
                            By accessing or using the Website, you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use the Website.
                        </div>
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold my-7 text-h5">Use of Website</div>
                            <div class="d-flex flex-column body-1">
                                <div>1.&nbsp;The Website is provided for informational and educational purposes only.
                                    You may use the Website for lawful purposes and in accordance with these Terms. You agree not to use the Website:
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">
                                        In any way that violates any applicable federal, state, local, or international law or regulation.
                                    </div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">
                                        To engage in any conduct that restricts or inhibits anyone’s use or enjoyment of the Website, or which,
                                        as determined by us, may harm us or users of the Website or expose them to liability.
                                    </div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">
                                        To interfere with the proper functioning of the Website or any other person’s use of the Website.
                                    </div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">
                                        To transmit, or procure the sending of, any advertising or promotional material, including
                                        any “junk mail,” “chain letter,” “spam,” or any other similar solicitation.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-for="(item, i) in websiteTermsArr"
                            class="d-flex flex-column"
                        >
                            <div class="font-weight-bold my-7 text-h5">{{ item.title }}</div>
                            <div class="ml-7 body-1">{{ i + 2 }}.&nbsp;{{ item.body }}</div>
                        </div> <!-- Arr Content -->
                        <div class="d-flex flex-column my-7">
                            <div class="font-weight-bold">Tasklogix (Pty) Ltd</div>
                            <div class="d-flex flex-column body-1">
                                <div>Address: 10 Windsor Street, Tzaneen, South Africa</div>
                                <div>Email: privacy@tasklogix.com.za</div>
                                <div>Phone: +27 87 238 2284</div>
                            </div>
                        </div> <!-- Address -->
                    </div>
                </v-tab-item> <!-- Website terms and conditions -->
                <v-tab-item>
                    <div class="mt-5 mx-16 full-height d-flex flex-column">
                        <div class="font-weight-bold my-7 text-h4">Privacy Policy for Tasklogix (Pty) Ltd</div>
                        <div class="body-1">
                            At Tasklogix (Pty) Ltd, we are committed to protecting the privacy and security of our clients' personal information.
                            This Privacy Policy explains how we collect, use, disclose, and protect your personal information.
                        </div>
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold my-7 text-h5">Collection of Personal Information</div>
                            <div class="d-flex flex-column body-1">
                                <div>1.&nbsp;We collect personal information from our clients when they sign up for our SaaS platform,
                                    communicate with us, or use our services. The personal information we collect may include:
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">Name and contact information (e.g., email address, phone number)</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">Payment information (e.g., credit card details)</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">User-generated content (e.g., task details, comments)</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">Usage data (e.g., IP address, device information)</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold my-7 text-h5">Use of Personal Information</div>
                            <div class="d-flex flex-column body-1">
                                <div class="d-flex">
                                    <div>2.&nbsp;</div>
                                    <div class="ml-1">
                                        We use personal information to provide and improve our services, communicate with our clients,
                                        and personalize their experience. Specifically, we use personal information for the following purposes:
                                    </div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">To provide and maintain our SaaS platform</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">To process payments and prevent fraud</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">To communicate with our clients about their accounts and our services</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">To personalize their experience and improve our services</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div class="ml-1">To comply with legal obligations and resolve disputes</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold my-7 text-h5">Disclosure of Personal Information</div>
                            <div class="d-flex flex-column body-1">
                                <div class="d-flex">
                                    <div>3.&nbsp;</div>
                                    <div class="ml-1">We may share personal information with third parties as necessary to provide and improve our services, as well as for legal and regulatory compliance. Specifically, we may share personal information with:</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div>Service providers who help us operate our business and provide our services (e.g., hosting providers, payment processors)</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div>Regulatory authorities or law enforcement officials as required by law</div>
                                </div>
                                <div class="ml-7 d-flex">
                                    <v-icon>mdi-circle-small</v-icon>
                                    <div>Other parties as directed by our clients</div>
                                </div>
                            </div>
                            <div class="mt-3">
                                We will not sell or rent your personal information to third parties for their marketing purposes without your explicit consent.
                            </div>
                        </div>
                        <div
                            v-for="(item, i) in privacyPolicyArr"
                            class="d-flex flex-column"
                        >
                            <div class="font-weight-bold my-7 text-h5">{{ item.title }}</div>
                            <div class="ml-7 body-1">{{ i + 4 }}.&nbsp;{{ item.body }}</div>
                        </div> <!-- Content Arr -->
                        <div class="d-flex flex-column my-7">
                            <div class="font-weight-bold">Tasklogix (Pty) Ltd</div>
                            <div class="d-flex flex-column body-1">
                                <div>Address: 10 Windsor Street, Tzaneen, South Africa</div>
                                <div>Email: privacy@tasklogix.com.za</div>
                                <div>Phone: +27 87 238 2284</div>
                            </div>
                        </div>
                    </div>
                </v-tab-item> <!-- Privacy Policy -->
            </v-tabs-items>
        </div> <!-- Tabs -->
        <div
            class="d-flex justify-center align-start"
            style="position: absolute; z-index: 5"
            :style="$vuetify.breakpoint.xsOnly ? 'right: 30px; top: 50px' : 'right: 30px; top: 5px'"
        >
            <div style="position: fixed">
                <v-tooltip left>
                    <template #activator="{ on, attrs }">
                        <v-btn
                            v-on="on"
                            v-bind="attrs"
                            fab
                            text
                            small
                            elevation="0"
                            @click.stop.prevent="$emit('update:privacyPolicy', false)"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </div>
        </div> <!-- Close Btn -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            displayTabContent: 0,
            websiteTermsArr: [
                {
                    title: 'Ownership of Content',
                    body: 'All content on the Website, including text, graphics, images, and other material (“Content”), is owned by or licensed to us. You may not use any Content on the Website without our express written permission.',
                },
                {
                    title: 'Links to Third-Party Websites',
                    body: 'The Website may contain links to third-party websites that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites. You access any such third-party websites at your own risk.',
                },
                {
                    title: 'Disclaimer of Warranties',
                    body: 'The Website is provided “as is” and “as available.” We make no representations or warranties of any kind, express or implied, as to the operation of the Website or the information, content, materials, or products included on the Website. To the full extent permissible by applicable law, we disclaim all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose.',
                },
                {
                    title: 'Limitation of Liability',
                    body: 'In no event shall we be liable for any direct, indirect, punitive, incidental, special, or consequential damages arising out of or in any way connected with the use of the Website or the inability to use the Website, or for any information, products, or services obtained through the Website, or otherwise arising out of the use of the Website, even if we have been advised of the possibility of such damages.',
                },
                {
                    title: 'Privacy Policy',
                    body: 'We are committed to protecting your privacy. Our Privacy Policy explains how we collect, use, and protect your personal information. Please read our Privacy Policy carefully before using the Website.',
                },
                {
                    title: 'Modifications to Terms and Website',
                    body: 'We reserve the right to modify these Terms and the Website at any time without prior notice. Your continued use of the Website after such modifications will constitute your acceptance of the new terms.',
                },
                {
                    title: 'Governing Law',
                    body: 'These Terms shall be governed by and construed in accordance with the laws of South Africa, without giving effect to any principles of conflicts of law.',
                },
                {
                    title: 'Reverse Engineering Prohibition',
                    body: 'You agree that you will not attempt to reverse engineer, decompile, disassemble, or otherwise attempt to discover the source code, object code, or underlying structure, ideas, or algorithms of the software or services provided by Tasklogix (Pty) Ltd. You acknowledge that such action is a violation of the intellectual property rights of Tasklogix (Pty) Ltd, and you may be liable for any damages caused by such action.',
                },
                {
                    title: 'Contact Us',
                    body: 'If you have any questions or comments about these Terms or the Website, please contact us at:',
                },
            ],
            privacyPolicyArr: [
                {
                    title: 'Data Security',
                    body: 'We implement appropriate technical and organizational measures to protect personal information from unauthorized access, disclosure, alteration, or destruction. We also require our service providers to maintain appropriate data security measures.',
                },
                {
                    title: 'Data Retention',
                    body: 'We retain personal information for as long as necessary to provide our services and fulfill our legal and regulatory obligations. We may also retain personal information for a reasonable period after our clients have terminated their accounts, as necessary to comply with legal and regulatory requirements or to resolve disputes.',
                },
                {
                    title: 'Your Rights',
                    body: 'You have the right to access, rectify, or delete your personal information, as well as to restrict or object to its processing. You may also request a copy of your personal information in a structured, machine-readable format. To exercise these rights, please contact us using the contact information below.',
                },
                {
                    title: 'Changes to this Privacy Policy',
                    body: 'We may update this Privacy Policy from time to time to reflect changes in our privacy practices. We will notify our clients of any material changes to this Privacy Policy by email or by posting a notice on our website.',
                },
                {
                    title: 'Contact Us',
                    body: 'If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at:',
                }
            ]
        }
    }
}
</script>